import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';

@Component({
  selector: 'app-hr-line-list-one',
  templateUrl: './../../../templates/forms/modals/hr-process-list.component.html',

})
export class HrProcessListComponent implements OnInit {

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  optionalParam;

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ProcessListId"

  lineList: any[] = [];
  constructor(public dataLoadService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.processName, field: 'OPERATION_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.processId, field: 'OPERATION_NO', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.buName, field: 'BU_NAME', sortable: true, resizable: true, hide: false }
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataLoadService.load('FG_HR_COMM_OPERATION',this.optionalParam).subscribe(results=>{
      this.lineList = results.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }

}
